<script setup>
import { RouterLink } from 'vue-router'
import { ROUTES } from '../../core/config/constants.js'
</script>

<template>
  <div class="document-page">
    <!-- Header -->
    <header class="document-header">
      <div class="header-content">
        <RouterLink :to="{ name: ROUTES.HOME }" class="back-link">
          <svg
            viewBox="0 0 24 24"
            width="20"
            height="20"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M5 12H19M12 5l7 7-7 7" />
          </svg>
          <span>חזרה</span>
        </RouterLink>
        <RouterLink :to="{ name: ROUTES.HOME }" class="logo-wrapper">
          <img src="@/assets/logo/logo_76.png" alt="GoFood" class="logo-img" />
          <span class="logo-text">GoFood</span>
        </RouterLink>
      </div>
    </header>

    <!-- Content -->
    <main class="document-main">
      <article class="document-content">
        <h1>תקנון שימוש – מערכת השילוט (GoFood)</h1>

        <p>
          מערכת השילוט הדיגיטלית (להלן: <strong>"מערכת השילוט"</strong> או
          <strong>"השירות"</strong>) הינה כלי טכנולוגי המסופק על ידי רוסמן לוגיסטיקה בע״מ (להלן:
          <strong>"רוסמן"</strong> / <strong>"החברה"</strong>) ללקוחותיה העסקיים, ומאפשר ללקוח
          ליצור, לעצב, להפיק, להדפיס ולהציג שלטי מבצעים, תגי מחיר, פרסומים ויזואליים אחרים בנקודת
          המכירה (להלן: <strong>"שלטים"</strong> / <strong>"תכני הלקוח"</strong>).
        </p>

        <p>
          השימוש במערכת השילוט כפוף לתקנון זה, לתקנון השימוש הכללי של המערכת, ולמדיניות הפרטיות של
          החברה (להלן יחד: <strong>"המסמכים המחייבים"</strong>). תקנון זה הוא מסמך משפטי מחייב ובו
          כתב פטור מאחריות וכתב שיפוי שיש לקרוא בעיון.
        </p>

        <h2>0. הגדרות והסכמה לתנאים</h2>
        <p>
          0.1.
          <strong>"לקוח" / "משתמש"</strong> – כל גוף עסקי או אדם הפועל מטעמו, אשר עושה שימוש במערכת
          השילוט.
        </p>
        <p>
          0.2.
          <strong>"שלט" / "תוכן הלקוח"</strong> – כל קובץ, תמונה, טקסט, מחיר, מבצע, סימון, סמליל
          (לוגו), מפרט או כל חומר אחר שהלקוח יוצר, מעלה, עורך, מפיק, מדפיס או מציג באמצעות מערכת
          השילוט.
        </p>
        <p>
          0.3.
          <strong
            >עצם הכניסה למערכת השילוט, יצירת שלט חדש, עריכת שלט קיים, שמירת שלט, ייצוא שלט, הדפסת
            שלט או הצגת שלט בכל אמצעי – מהווה הסכמה מלאה, מודעת ומפורשת של הלקוח לתקנון זה ולכל
            תנאיו, ובכלל זאת לכתב הפטור מאחריות ולכתב השיפוי המפורטים להלן.</strong
          >
        </p>
        <p>0.4. אם אינך מסכים לתנאי כלשהו מתנאי תקנון זה – אין לעשות שימוש במערכת השילוט.</p>
        <p>
          0.5. בכל מקום בו תופיע תיבת אישור / חלון הסכמה / כפתור "אני מסכים" – סימון או לחיצה על
          הכפתור מהווים אישור פעיל ומפורש להסכמה לתקנון, ויהוו ראיה קבילה לתיעוד ההסכמה.
        </p>

        <h2>1. ייעוד מערכת השילוט וגבולות השירות</h2>
        <p>
          1.1. מערכת השילוט הינה כלי תוכנתי לעיצוב, יצירה, שמירה והפקה של שלטים על ידי הלקוח עצמו.
          השליטה בתוכן הסופי של השלט – לרבות בחירת מוצרים, מחירים, ניסוחים, צבעים, לוגואים, תמונות,
          הצהרות, הכרזות, מבצעים, אזהרות, סימונים תזונתיים, סימוני אלרגנים וכל מידע אחר – נתונה
          באופן בלעדי בידי הלקוח.
        </p>
        <p>
          1.2. החברה מספקת תשתית טכנולוגית בלבד. אין לראות בחברה גורם המעניק ייעוץ משפטי, ייעוץ
          רגולטורי, ייעוץ פרסומי, ייעוץ עיצובי או חוות דעת מקצועית כלשהי לגבי תוכן הלקוח.
        </p>
        <p>
          1.3. תבניות (templates), צבעים מוצעים, פריסות (layouts), הצעות אוטומטיות והודעות חכמות
          המופיעות במערכת השילוט הם הצעות לנוחות בלבד ואינם מהווים אישור או המלצה משפטית/רגולטורית
          לתוכן הסופי. הלקוח אחראי לבדוק ולאשר את התוכן הסופי בעצמו לפני הפקה ופרסום.
        </p>
        <p>
          1.4. החברה רשאית, לפי שיקול דעתה הבלעדי וללא הודעה מוקדמת, לשנות, להוסיף, לגרוע, לעדכן או
          להפסיק תכונות של מערכת השילוט, וכן להגביל או להפסיק את הגישה למערכת השילוט.
        </p>

        <h2>2. אחריות הלקוח לתוכן השלט</h2>
        <p>
          2.1.
          <strong
            >האחריות המלאה, הבלעדית והמוחלטת על תוכן השלט, על נכונותו, על דיוקו, על חוקיותו ועל
            השלכותיו – חלה על הלקוח בלבד.</strong
          >
        </p>
        <p>
          2.2. הלקוח מתחייב כי כל שלט שיופק על ידו באמצעות מערכת השילוט יעמוד בכל דרישות הדין החל
          בישראל, לרבות (אך לא רק):
        </p>
        <ul>
          <li>
            חוק הגנת הצרכן, התשמ״א-1981 ותקנותיו, לרבות תקנות הגנת הצרכן (מחיר ליחידת מידה) וכלל
            הוראות סימון מחירים, מבצעים, הנחות, השוואת מחירים והצגת מחיר רגיל לעומת מחיר מבצע.
          </li>
          <li>
            חוק להסדרת הפיקוח על מצרכים ושירותים וההוראות הרלוונטיות לסימון מוצרים מפוקחים/קצובים.
          </li>
          <li>
            דיני סימון מזון: חוק הגנה על בריאות הציבור (מזון), התשע״ו-2015, תקנות בריאות הציבור
            (מזון) (סימון תזונתי), תקנות סימון אלרגנים, סימון "סימון אדום/ירוק", רכיבים, ערכים
            תזונתיים, תוקף, אזהרות וייעודים.
          </li>
          <li>
            דיני אריזות ומשקלים, לרבות סימון משקל נטו/ברוטו, יחידת מידה ומחיר ליחידת מידה, ככל
            שרלוונטי.
          </li>
          <li>
            חוקי הפרסום וההגינות בפרסום: חוק הגנת הצרכן (איסור פרסום מטעה), חוק עוולות מסחריות,
            הוראות הרשות להגנת הצרכן ולסחר הוגן, וכל הוראת רגולטור ענייני אחר.
          </li>
          <li>
            דיני קניין רוחני: זכויות יוצרים, סימני מסחר, מדגמים, זכויות מבצעים – הן של החברה, הן של
            יצרני מוצרים, הן של צדדים שלישיים והן של ספקי תוכן (פונטים, אייקונים, תמונות).
          </li>
          <li>
            דיני פרטיות והגנת המידע, ככל שתוכן השלט כולל פרטים אישיים, תמונות אנשים או מידע מזהה
            אחר.
          </li>
          <li>הוראות כשרות, סימון כשרות וגופי ההסמכה הרלוונטיים, ככל שהשלט מציג מוצרים ככשרים.</li>
          <li>הוראות סימון אזהרה (אלכוהול, טבק, מוצרים בעלי הגבלות גיל וכד').</li>
        </ul>
        <p>
          2.3. הלקוח מצהיר ומתחייב כי המחירים, המבצעים, אחוזי ההנחה, תאריכי התוקף, המלאי הרלוונטי
          ותנאי הרכישה המוצגים בשלט – הינם נכונים, עדכניים, מדויקים ובני יישום בנקודת המכירה שלו,
          וכי קיים אצלו תיעוד מלא של מחיר רגיל לעומת מחיר מבצע, של תאריכי התחלה וסיום מבצע, ושל כל
          מסמך אחר הנדרש על פי דין.
        </p>
        <p>
          2.4. הלקוח אחראי באופן בלעדי לכך שהמוצר המופיע בשלט קיים אצלו במלאי, מתומחר נכון בקופה,
          ומיושם בפועל בכל ערוצי המכירה.
        </p>
        <p>
          2.5. הלקוח אחראי באופן בלעדי לבדוק את השלט המודפס/המוצג בעין לפני הצבתו בנקודת המכירה,
          לוודא היעדר טעויות הקלדה, טעויות מחיר, טעויות הקלדה במבצע, טעויות תרגום, חוסרים בסימון
          אלרגנים/אזהרות וכל פגם אחר.
        </p>

        <h2>3. תכנים שאסור להעלות / להפיק במערכת השילוט</h2>
        <p>3.1. הלקוח מתחייב שלא להפיק, לפרסם או להציג באמצעות מערכת השילוט:</p>
        <ul>
          <li>
            תוכן המפר זכויות יוצרים, סימני מסחר, מדגמים או כל זכות קניין רוחני אחרת של צד שלישי.
          </li>
          <li>תמונות, לוגואים או חומרים שאין לו הרשאה מפורשת מבעל הזכויות לעשות בהם שימוש.</li>
          <li>
            תוכן מטעה, כוזב, מפר חוק, פוגעני, מסית, גזעני, פוגע בפרטיות, או מנוגד לתקנת הציבור.
          </li>
          <li>
            פרסום השוואתי / מציאות מסחרית מטעה / "מבצע" שאינו מבצע אמיתי / מחיר רגיל פיקטיבי / סימון
            "מחיר היה" כוזב.
          </li>
          <li>תוכן הפוגע בפרטיותם של אנשים, לרבות תמונות פרטיות ללא הסכמה.</li>
          <li>
            תוכן מסוג "דבר פרסומת" המופץ ללא הסכמה לפי חוק התקשורת (בזק ושידורים), התשמ״ב-1982.
          </li>
          <li>סימוני כשרות, סימוני בריאות או סימוני בטיחות שאינם מאושרים על ידי הגוף המוסמך.</li>
          <li>תוכן המכיל וירוסים, קוד זדוני, נוזקה או כל מנגנון פגיעה במערכת.</li>
        </ul>
        <p>
          3.2. החברה רשאית, לפי שיקול דעתה הבלעדי וללא הודעה מוקדמת, להסיר תוכן, לחסום שלטים, לחסום
          חשבון או להפסיק שירות אם נודע לה על חשד להפרת סעיף זה או הוראת דין כלשהי.
        </p>

        <h2>4. כתב פטור מאחריות מלא של החברה</h2>
        <p>
          4.1.
          <strong
            >מערכת השילוט מסופקת ללקוח "כמות שהיא" (As-Is) ו-"כפי שהיא זמינה" (As-Available), ללא כל
            אחריות, מפורשת או משתמעת.</strong
          >
        </p>
        <p>
          4.2.
          <strong
            >החברה אינה אחראית, באופן ישיר או עקיף, לכל נזק, הפסד, הוצאה, חיוב כספי, קנס מנהלי, קנס
            פלילי, תביעה, דרישה, תלונה או הליך משפטי שייגרמו ללקוח, ללקוחותיו, לעובדיו, לספקיו או
            לכל צד שלישי – כתוצאה מהשלטים שהפיק הלקוח, מתוכנם, מהדפסתם, מהצבתם, מהצגתם, מטעות בהם או
            מכל שימוש בהם.</strong
          >
        </p>
        <p>4.3. בכלל זאת, ומבלי לגרוע מכלליות האמור, החברה לא תישא באחריות בגין:</p>
        <ul>
          <li>
            טעויות במחיר, באחוז ההנחה, בסכום החיסכון, במחיר ליחידת מידה, או בכל נתון מספרי בשלט.
          </li>
          <li>
            טעויות בסימון מבצעים, בתאריכי תוקף, בתנאי המבצע, בהגבלת כמות, ב"מחיר היה" / "מחיר רגיל".
          </li>
          <li>
            טעויות בסימון אלרגנים, רכיבים, ערכים תזונתיים, סימון "סימון אדום/ירוק", סימון מקור,
            סימון כשרות, או כל סימון מחויב על פי דין.
          </li>
          <li>חוסרים, חוסר התאמה, או טעויות תרגום בתוכן השלט.</li>
          <li>שימוש בתמונה, לוגו, פונט, אייקון או חומר עיצובי בלא הרשאת בעל הזכויות.</li>
          <li>
            הפרת הוראות חוק הגנת הצרכן, חוק להסדרת הפיקוח על מצרכים ושירותים, חוק הגנה על בריאות
            הציבור (מזון), חוק התקשורת (בזק ושידורים), חוקי פרסום, חוקי קניין רוחני או כל חוק אחר.
          </li>
          <li>
            תלונות צרכנים, חקירות של רשויות, קנסות מנהליים, צווי חדילה, צווי הסרה, תביעות נזיקיות
            וכל הליך אזרחי, פלילי או מנהלי הקשור בשלט.
          </li>
          <li>אובדן הכנסות, אובדן רווחים, פגיעה במוניטין או פגיעה בקשרי לקוחות של הלקוח.</li>
          <li>
            תקלות טכניות במערכת השילוט, תקלות בשמירה, תקלות בייצוא, תקלות בהדפסה, תקלות בצבעי הדפסה,
            איכות הדפסה, חיתוך, גודל, פורמט או כל תקלה אחרת.
          </li>
          <li>
            אובדן או פגיעה בקבצי השלטים שמורים, לרבות במקרה של תקלה, מחיקה, השבתה או הפסקת השירות.
          </li>
        </ul>
        <p>
          4.4.
          <strong
            >האחריות הכוללת של החברה כלפי הלקוח, ככל שתחול חרף האמור לעיל, מוגבלת לסכום הסמלי של ש״ח
            אחד (1 ₪) ובכל מקרה לא תעלה על הסכום ששילם הלקוח עבור מערכת השילוט בפרט (ככל ששילם) ב-12
            החודשים שקדמו לאירוע, הנמוך מבין השניים.</strong
          >
        </p>
        <p>
          4.5. אין באמור בסעיף זה כדי לגרוע מהוראות חוק כלשהן שאינן ניתנות להתניה, לרבות לעניין נזק
          גוף או נזק שנגרם בכוונה או ברשלנות חמורה של החברה.
        </p>

        <h2>5. כתב שיפוי</h2>
        <p>
          5.1.
          <strong
            >הלקוח ישפה ויפצה את החברה, את בעלי מניותיה, מנהליה, עובדיה, נותני שירותיה וכל הפועל
            מטעמה (להלן: <em>"גורמי החברה"</em>), באופן מלא ומיידי, מיד עם דרישתם הראשונה ובכתב,
            בגין כל נזק, הוצאה, אובדן, הפסד, קנס, חיוב, תביעה, דרישה או הליך משפטי (לרבות שכר טרחת
            עורכי דין סבירים, הוצאות משפט, הוצאות מומחים והוצאות פשרה) שייגרמו לגורמי החברה –
            במישרין או בעקיפין – כתוצאה מ:</strong
          >
        </p>
        <ul>
          <li>שלט שהופק, נשמר, יוצא, הודפס או הוצג על ידי הלקוח באמצעות מערכת השילוט.</li>
          <li>תלונה צרכנית, חקירה רגולטורית, צו, קנס או תביעה הנובעים מתוכן השלט.</li>
          <li>
            הפרת הוראות חוק כלשהן בידי הלקוח (לרבות חוקי הגנת הצרכן, סימון מזון, פרסום, קניין רוחני,
            פרטיות).
          </li>
          <li>הפרה של תקנון זה או של ההצהרות וההתחייבויות של הלקוח לפיו.</li>
          <li>שימוש בתוכן (תמונה, לוגו, פונט, מותג) בלא הרשאת בעל הזכויות.</li>
          <li>פעולה רשלנית, מטעה או זדונית של הלקוח, עובדיו, סוכניו או מי מטעמו.</li>
        </ul>
        <p>
          5.2. החברה תיידע את הלקוח בכל הליך/דרישה רלוונטיים, ותהיה רשאית, לפי שיקול דעתה, לנהל את
          ההגנה בעצמה או באמצעות עורכי דין מטעמה – על חשבון הלקוח.
        </p>
        <p>5.3. הלקוח לא יבצע פשרה, הודאה או ויתור בשם החברה ללא אישור החברה מראש ובכתב.</p>

        <h2>6. הצהרות והתחייבויות הלקוח</h2>
        <p>6.1. הלקוח מצהיר ומתחייב כי:</p>
        <ul>
          <li>
            הוא בוחן ומאמת את כל פרטי השלט (טקסט, מחיר, מבצע, תוקף, סימונים, תמונה, לוגו) באופן
            עצמאי לפני הפקתו ופרסומו.
          </li>
          <li>
            יש לו את כל ההרשאות והזכויות הנדרשות לעשות שימוש בכל תוכן שהוא מעלה למערכת (תמונות,
            לוגואים, מחירים, מותגים, סימני מסחר).
          </li>
          <li>
            הוא יצביע על המחיר/המבצע בהתאם להוראות הדין, לרבות שמירת תיעוד של "מחיר היה" / "מחיר
            רגיל" בהתאם לתקנות.
          </li>
          <li>
            לפי הצורך, יבדוק את התאמת השלט הסופי לתכולת המוצר בפועל (אריזה/מקט/יצרן/משקל/תוקף),
            לסימוני האלרגנים, לסימוני התזונה ולסימני הכשרות.
          </li>
          <li>
            הוא יסיר/יחליף/יעדכן שלטים שתוקפם פג, שמבצעם הסתיים, או שאינם משקפים עוד את המציאות.
          </li>
          <li>הוא לא ישתמש במערכת השילוט בניגוד לתקנון, לדין, או באופן הפוגע בצדדים שלישיים.</li>
        </ul>

        <h2>7. קניין רוחני, סימני מסחר ולוגואים</h2>
        <p>
          7.1. כל זכויות הקניין הרוחני במערכת השילוט עצמה (קוד, ממשק, עיצוב, תבניות, אלמנטים גרפיים
          המסופקים על ידי החברה) שייכות לחברה ו/או לצדדים שלישיים שהרשו לה שימוש.
        </p>
        <p>
          7.2. לוגואים, סימני מסחר, אריזות מוצרים ותמונות מוצרים של ספקים/יצרנים, אם וכאשר זמינים
          במערכת – מוצגים לנוחות בלבד, ועצם זמינותם אינה מקנה ללקוח רישיון או הרשאה כלשהי לעשות בהם
          שימוש מעבר לפעילות העסקית הסבירה והרגילה של הלקוח כלקוחה של החברה. הלקוח אחראי לבדוק
          עצמאית כל הרשאת שימוש מול בעלי הזכויות הרלוונטיים.
        </p>
        <p>
          7.3. כל זכויות הקניין הרוחני בתוכן השלטים שיצר הלקוח (תכני הלקוח), שאינו אלמנטים שמסופקים
          על ידי החברה – שייכות ללקוח. הלקוח מעניק לחברה רישיון לא בלעדי, חינמי, להעתיק, לאחסן ולעבד
          את תכני הלקוח אך ורק לצורך תפעול השירות, גיבויו, אבטחתו ושיפורו.
        </p>

        <h2>8. אחסון, גיבוי, מחיקה והפסקת שירות</h2>
        <p>
          8.1. החברה רשאית למחוק שלטים, חשבונות, נתונים ותכני לקוח – לפי שיקול דעתה ובהתאם לדין –
          במקרה של הפרת תקנון, חשד להפרה, סיום ההתקשרות עם הלקוח, או הפסקת השירות.
        </p>
        <p>
          8.2. החברה אינה מתחייבת לזמינות רציפה של מערכת השילוט, להיעדר תקלות, לאיכות הדפסה או
          לשמירה לאורך זמן של תכני הלקוח. הלקוח אחראי לשמור גיבוי משלו של חומרים שחשובים לו.
        </p>
        <p>8.3. החברה רשאית להפסיק את השירות (או חלק ממנו) בכל עת, על פי שיקול דעתה ובכפוף לדין.</p>

        <h2>9. הדפסה, הפקה וצדדים שלישיים</h2>
        <p>
          9.1. הדפסה, ייצור, חיתוך, אספקה והצבה של השלט בנקודת המכירה הם באחריות הלקוח (במישרין או
          באמצעות בית דפוס/ספק מטעמו). החברה אינה אחראית לאיכות ההדפסה הסופית, להבדלי צבע,
          לקלוריזציה, לחיתוך, לעמידות החומר או לכל פגם בתוצר הפיזי.
        </p>
        <p>
          9.2. ככל שהלקוח עושה שימוש בשירותי הדפסה/ייצור של צד שלישי, יחסי הלקוח מול אותו צד שלישי
          הם עניינו של הלקוח בלבד.
        </p>

        <h2>10. שינויים בתקנון</h2>
        <p>
          10.1. החברה רשאית לעדכן תקנון זה בכל עת, לפי שיקול דעתה. נוסח התקנון העדכני יפורסם במערכת
          ויחול על כל שימוש מאותו מועד ואילך.
        </p>
        <p>
          10.2. המשך שימוש במערכת השילוט לאחר עדכון התקנון מהווה הסכמה לתקנון המעודכן. אם אינך מסכים
          לעדכון – עליך להפסיק את השימוש.
        </p>

        <h2>11. סמכות שיפוט ודין</h2>
        <p>11.1. על תקנון זה ועל השימוש במערכת השילוט יחולו דיני מדינת ישראל בלבד.</p>
        <p>
          11.2. סמכות השיפוט הבלעדית בכל עניין הקשור לתקנון זה או לשימוש במערכת השילוט תהיה נתונה
          לבתי המשפט המוסמכים במחוז חיפה, אלא אם הוסכם אחרת בכתב.
        </p>

        <h2>12. כתב הסכמה ופטור – סיכום מחייב</h2>
        <p>
          <strong>על ידי המשך השימוש במערכת השילוט (לרבות לחיצה על "שלט חדש" או "אני מסכים")</strong
          >, הלקוח מצהיר ומאשר כי:
        </p>
        <ul>
          <li>קרא את התקנון, הבין אותו וקיבל הזדמנות סבירה להתייעץ עם יועץ משפטי טרם הסכמתו.</li>
          <li>מקבל על עצמו את האחריות המלאה והבלעדית לכל שלט שיפיק באמצעות מערכת השילוט.</li>
          <li>
            פוטר את החברה ואת גורמי החברה מכל אחריות, ישירה ועקיפה, בקשר לתוכן השלט ולתוצאותיו.
          </li>
          <li>
            מתחייב לשפות את החברה ואת גורמי החברה בגין כל תביעה, דרישה, נזק או הוצאה הקשורים לשלט,
            כמפורט בסעיף 5 לעיל.
          </li>
        </ul>

        <p class="contact-line">
          לפניות בנושא תקנון זה: <a href="mailto:gofood@rosman.co.il">gofood@rosman.co.il</a>
        </p>
      </article>
    </main>

    <!-- Footer -->
    <footer class="document-footer">
      <p>© 2024 GoFood. כל הזכויות שמורות.</p>
    </footer>
  </div>
</template>

<style scoped>
.document-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-primary);
}

.document-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--border-color);
  padding: var(--spacing-md) var(--spacing-lg);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 800px;
  margin: 0 auto;
}

.back-link {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  color: var(--text-primary);
  text-decoration: none;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  transition: color var(--transition-fast);
}

.back-link:hover {
  color: #d97706;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  text-decoration: none;
}

.logo-img {
  width: 32px;
  height: 32px;
  border-radius: var(--border-radius-sm);
}

.logo-text {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--text-primary);
}

.document-main {
  flex: 1;
  padding: var(--spacing-lg);
}

.document-content {
  max-width: 800px;
  margin: 0 auto;
  background: white;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-xl);
  line-height: 1.8;
}

.document-content h1 {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--text-primary);
  margin: 0 0 var(--spacing-xl) 0;
  padding-bottom: var(--spacing-md);
  border-bottom: 2px solid #d97706;
}

.document-content h2 {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  margin: var(--spacing-xl) 0 var(--spacing-md) 0;
}

.document-content p {
  margin: 0 0 var(--spacing-sm) 0;
  color: var(--text-secondary);
}

.document-content ul {
  margin: var(--spacing-sm) 0 var(--spacing-md) 0;
  padding-right: var(--spacing-xl);
}

.document-content li {
  margin-bottom: var(--spacing-xs);
  color: var(--text-secondary);
}

.document-content strong {
  color: var(--text-primary);
}

.document-content a {
  color: #d97706;
  text-decoration: none;
}
.document-content a:hover {
  text-decoration: underline;
}

.contact-line {
  margin-top: var(--spacing-xl);
  padding-top: var(--spacing-md);
  border-top: 1px dashed var(--border-color);
  font-size: var(--font-size-sm);
}

.document-footer {
  text-align: center;
  padding: var(--spacing-lg);
  color: var(--text-muted);
  font-size: var(--font-size-xs);
  border-top: 1px solid var(--border-color);
}

.document-footer p {
  margin: 0;
}

@media (max-width: 768px) {
  .document-content {
    padding: var(--spacing-lg);
  }

  .document-content h1 {
    font-size: var(--font-size-xl);
  }
}
</style>
